import React from 'react';
import { TutorialPage } from '../TutorialPage';
import { Target } from 'lucide-react';
import { TooltipPosition } from '../../../types/tutorial';

export interface GuessPageProps {
  currentPage: number;
  totalPages: number;
  onNext: () => void;
  onPrevious: () => void;
  onSkip: () => void;
  onFinish: () => void;
  targetId?: string;
  tooltipPosition?: TooltipPosition;
}

/**
 * Tutorial Page 4: Make a Guess
 * Tooltip positions relative to submit-guesses element
 */
export const GuessPage: React.FC<GuessPageProps> = ({
  targetId = 'submit-guesses',
  tooltipPosition = 'right',
  ...props
}) => {
  return (
    <TutorialPage
      title="Make a Guess"
      targetId={targetId}
      tooltipPosition={tooltipPosition}
      {...props}
    >
      <div className="space-y-4">
        {/* Visual Indicator */}
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-950/30 dark:to-indigo-950/30 border border-blue-200 dark:border-blue-800 rounded-lg text-center">
          <Target className="w-12 h-12 mx-auto mb-3 text-blue-600 dark:text-blue-400" />
          <p className="font-semibold text-foreground mb-2">4 Attempts Available</p>
          <p className="text-sm text-muted-foreground">
            Master this investing puzzle! Each incorrect guess reveals a new hint in your daily stock challenge.
          </p>
        </div>
      </div>
    </TutorialPage>
  );
};

export default GuessPage;
